module.exports = __webpack_public_path__ + "static/media/52.5d70610.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/52.wav
// module id = YOMG
// module chunks = 0